import { useLang } from '@/i18n';
import EfFooterTc from '@elem/ui/ef-footer-tc';
import EfSpec from '@elem/ui/ef-spec';
import { useState } from 'react';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.FootTC');
    const [list, setList] = useState<any[]>([
        {
            isHeader: true,
            title: 'RIVER 3 に関する販売規約',
        },
        {
            title: '1.RIVER 3および関連セットは2024年9月1日（日）にて正式販売予定です。',
        },
        {
            title: '2.販売の台数には一部限りがあり、なくなり次第予約販売となりますので、ご了承ください。',
        },
        {
            title: '3.本ウェブサイトでご注文される場合、発送地域は日本のご住所のみの対応となります。',
        },
        {
            title: '4.製品を安全に配送するため、RIVER 3、ソーラーパネルおよびアクセサリーは別々の梱包で発送いたします。ご了承ください。',
        },
        {
            title: (
                <>
                    5.ご不明点がありましたら、弊社アフターサービス<a href="mailto:hello.jp@ecoflow.com">hello.jp@ecoflow.com</a>までお問い合わせください。
                </>
            ),
        },
        {
            title: (
                <>
                    6.注文後、商品が発送されていない場合に限り、ご注文のキャンセルおよび返金を申請することができます。お客様のご都合により、購入商品到着後30日以内に返品される場合、初回取引手数料と送料をご請求させていただきますので、ご了承ください。
                    <a href="https://jp.ecoflow.com/pages/online-store-policy" target="_blank" rel="noreferrer">
                        返品・返金について
                    </a>
                    詳しくはこちらをご覧ください。
                </>
            ),
        },
    ]);

    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfFooterTc list={list} />
        </div>
    );
}
